"use client";

import { useEffect } from "react";
import { processOfflineQueue } from "@/lib/offline-sync";

export default function OfflineSyncProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const handleOnline = () => {
      console.log("[OfflineSync] Device is back online. Processing queue...");
      processOfflineQueue();
    };

    window.addEventListener("online", handleOnline);

    // Try processing once when the app loads, in case it came back online while closed
    if (navigator.onLine) {
      processOfflineQueue();
    }

    return () => window.removeEventListener("online", handleOnline);
  }, []);

  return <>{children}</>;
}
